const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/admin/gamification/rewards/pending.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
export const Route = createFileRoute("/_authenticated/_feature_announcement/admin/gamification/rewards/pending")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Pending Reward Claims",
      description: "Tab title for pending reward claims"
    })
  }
});